import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxPaginationModule } from 'ngx-pagination'; 
import { NgbModule, NgbDatepickerConfig, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateNativeAdapter } from './_services/datepicker-adapter';
import { NgbDateMomentParserFormatter } from './_services/ngb-date-moment-parser-formatter';
import { InputTrimModule } from 'ng2-trim-directive';

import { pipes } from './_pipes/index';
import { HeaderComponent } from './layout/header/header.component';
import { FilterPipe } from './_pipes/filter.pipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MyDatePickerModule,
    NgxPaginationModule,
    NgbModule.forRoot(),
    NgbDatepickerModule,
    InputTrimModule
  ],
  declarations: [pipes, HeaderComponent, FilterPipe],
  providers: [
    NgbDatepickerConfig,
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    {
      provide:  NgbDateParserFormatter,
      useFactory:  ()  =>  {  return  new  NgbDateMomentParserFormatter('mm/dd/yyyy') }
    }
  ],
  exports: [CommonModule, FormsModule, MyDatePickerModule, NgbModule, InputTrimModule, NgbDatepickerModule, ReactiveFormsModule, pipes, HeaderComponent, NgxPaginationModule]
})
export class SharedModule { }




// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts